import { nextTick } from '@patrianna/shared-utils'
import cx from 'classnames'
import Link from 'next/link'
import type { SyntheticEvent, MouseEvent } from 'react'

import { Picture } from 'src/components/Picture'
import { ImageType } from 'src/components/Picture/Picture.types'

import classes from './styles.module.scss'

type Props = {
  onClick?: (e: SyntheticEvent) => void
  dataTest: string
  src: string
  alt: string
  className?: string
  priority?: boolean
  loading?: 'lazy' | 'eager'
  url?: string
  openInNewTab?: boolean
}

export default function BannerTile(props: Props) {
  const { src, onClick, priority, className, dataTest, alt, loading = 'lazy', url, openInNewTab } = props
  const Component = url ? Link : 'div'

  const handlerClick = (e: MouseEvent<HTMLAnchorElement> & MouseEvent<HTMLDivElement>) => {
    nextTick().then(() => {
      onClick?.(e)
    })
  }

  return (
    <Component
      href={url || null}
      target={openInNewTab && '_blank'}
      className={cx(classes.root, className)}
      onClick={handlerClick}
      role='button'
      data-banner
      data-test={dataTest}
      prefetch={false}
    >
      <Picture src={src} alt={alt} loading={loading} type={ImageType.BANNER} priority={priority} />
    </Component>
  )
}
